<template>
  <div class="specialView-container">
    <section class="specialView-image_container okView-color">
      <span class="specialView-image okView-image"></span>
    </section>
    <section class="specialView-info_container ">
        <h2 class="specialView-info_title" > ¡De acuerdo! Vamos a continuar el estudio de tu hipoteca con Helloteca</h2>
        <p class="specialView-info_text" style="margin-bottom: 0;">Nuestro equipo de <strong>Helloteca</strong> está listo para ayudarte a encontrar la mejor solución adaptada a tus necesidades.</p>
        <p class="specialView-info_text">Indica el producto y la Comunidad Autónoma, y seguiremos el estudio de tu hipoteca desde la plataforma de Helloteca.</p>
        <div class="main-form_info">  
          <ValidationObserver ref="formObserver">
            <InputSelect
            class="first-input"
                :options  ="$store.state.inputOptionsVariables.productos_helloteca"
                placeholder = "Selecciona producto"
                @valueChanged = "(value) => handleValueChanged('producto',value)"
            ></InputSelect>
            <InputSelect
                :options = "$store.state.inputOptionsVariables.ccaa"
                placeholder = "Selecciona comunidad autónoma"
                :selected = "$store.state.prescoringData.ccaa"
                @valueChanged = "(value) => handleValueChanged('ccaa',value)"
            ></InputSelect>
            <InputText 
              label = "Breve descripción de lo que buscas"
              :rows = 3
              @valueChanged = "(value) => handleValueChanged('comentario',value)"
            />              
            <DatosPersonales />              
          </ValidationObserver>
        </div>
        <NavegationButtons 
            :nextStepButtonActive = "canContinue"
            nextStepButtonText = "Continuar con Helloteca"
            backStepButtonText = "Atrás"
            :nextStepCallback = sendData
        ></NavegationButtons>
    </section>
  </div>
</template>

<script>
import NavegationButtons from '../common/NavegationButtons.vue';
import InputSelect from '../common/InputSelect.vue';
import InputText from '../common/InputText.vue';
import DatosPersonales from '../common/DatosPersonales.vue';
import { ValidationObserver } from "vee-validate";

export default {
  name: 'productos_helloteca',
  components: {
    ValidationObserver,
      NavegationButtons,
      InputSelect,
      InputText,
      DatosPersonales
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.commit('resetProducto');
  },
  methods: {
      goEnd() {
        window.location.href = 'https://myinvestor.es/hipotecas/';
      },
      async sendData() {          
        const isValid = await this.$refs.formObserver.validate();
        if (isValid) {
          this.$store.dispatch('registrarLeadBasico');
          this.$store.dispatch('goNext', 'ok_view_helloteca');
        } else {
          // El formulario tiene errores
          console.log('Por favor, corrige los errores.');
        }
      },
      handleValueChanged(field, value){
          this.$store.commit('updatePrescoringData', { field, value });
      }
  },
  computed: {
        nextStep(){
            return true;
        },
        canContinue(){
          const { nombre, apellidos, telefono, email, my_hello_check, producto, ccaa} = this.$store.state.prescoringData;
            return nombre !== null && nombre !== ''
                    && apellidos !== null && apellidos !== ''
                    && telefono !== null && telefono !== ''
                    && email !== null && email !== ''
                    && producto !== null && producto !== ''
                    && ccaa !== null && ccaa !== ''
                    && my_hello_check !== null && my_hello_check == true;
        }        
    }
}
</script>

<style scoped>
  .main-form_info .first-input {
    margin-bottom: 20px;
  }
  .okView-color {
    background: #DFF1ED;
  }
  .okView-image {
    width: 508px;
    height: 271px;
    flex-shrink: 0;
    background: url(../../assets/laptop.png) #DFF1ED 50% / cover no-repeat;
  }
  .okview-button_container{
    justify-content: center;
    width: 100%;
  }
</style>
